import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=3444016c"
import script from "./Email.vue?vue&type=script&lang=js"
export * from "./Email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3444016c')) {
      api.createRecord('3444016c', component.options)
    } else {
      api.reload('3444016c', component.options)
    }
    module.hot.accept("./Email.vue?vue&type=template&id=3444016c", function () {
      api.rerender('3444016c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Settings/Email.vue"
export default component.exports